import { isEmpty } from 'lodash';
import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
    width: 100%;
    padding: 5px;
    textarea{
        width: 100%;
        padding: 10px;
        padding-left: 20px;
        outline: none;
        resize: none;
        border: none;
        max-height: 100px;
        font-family: "PT Sans", sans-serif;
        overflow-y: hidden;
    }

`;

export default function TextArea(props: any) {
    const [currentValue, setCurrentValue] = useState('');

    const textareaRef = useRef<any>(null);

    useEffect(() => {
        textareaRef.current.style.height = "0px";
        const scrollHeight = textareaRef.current.scrollHeight;
        textareaRef.current.style.height = scrollHeight - 20 + "px";
    }, [currentValue]);

    useEffect(() => {
        if (isEmpty(props.value))
            setCurrentValue("");
    }, [props.value]);

    const onChange = (e: any) => {
        setCurrentValue(e.target.value);
        props.onChange(e)
    }

    const onKeyPress = (e: any) => {
        if (e.key === "Enter" && !e.shiftKey) {
            e.preventDefault();
            props.onEnter();
            setCurrentValue('');
        }
    }

    return (
        <Wrapper>
            <textarea
                ref={textareaRef}
                placeholder={props.placeholder}
                value={currentValue}
                onKeyPress={onKeyPress}
                onChange={onChange}
                spellCheck={props.spellCheck}
                disabled={props.disabled}
            >
            </textarea>
        </Wrapper >
    )
}
